/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';


/* ++++++++++ --------------- GENERAL CONFIGS - TRENDING CONFIGS : STYLES --------------- ++++++++++ */
export default {
  generalconfig: {
    '& .button-wrapper': {
      marginRight: '6px'
    },
    '& .inline': {
      display: 'inline-block',
      paddingRight: '0.7em'
    },
    '& .imageuploader' : {
      marginTop: '14px'
    },
    '& .controls-tooltips': {
      position: 'relative',
      top: pxToEm(30),
      left: pxToEm(-30),
      '& .empty': {
        width: '16px'
      },
      '& .tooltip-wrapper': {
        '& .top-tooltip': {
          position: 'absolute',
          bottom: pxToEm(85),
          left: pxToEm(-196),
          width: '289px',
          background: 'rgb(255, 255, 255)',
          boxShadow: '0px 4px 12px 0px rgba(48, 48, 48, 0.2)',
          borderRadius: '10px',
          padding: '14px',
          textAlign: 'center',
          zIndex: '1000'
        },
        '& .bottom-tooltip': {
          position: 'absolute',
          top: pxToEm(45),
          left: pxToEm(-68),
          maxWidth: '289px',
          boxShadow: '2px 6px 12px 0px rgba(14, 31, 74, 0.1)',
          zIndex: '2000'
        },
        '& .tooltips-image': {
          maxWidth: '289px',
          maxHeight: '289px'
        },
      },
    },
    '& .field': {
      width: '30%',
      maxWidth: pxToEm(215)
    },
    '& .button': {
      width: 'auto',
      height: pxToEm(56)
    },
    '& .square-button': {
      '& > .group': {
          display: 'flex',
          flexFlow: 'row wrap',
          marginTop: pxToEm(16),
          '& .control': {
              width: pxToEm(64),
              minWidth: pxToEm(64),
              maxWidth: pxToEm(64),
              flex: 1
          }
      }
  }
  }
};
